/**
 * An object containing all supported chart types that include
 * description and limitations for each type.
 */

export const CHART_TYPES = {
  line: {
    description: {
      name: 'Line Chart',
      type: 'line',
    },
    market: {
      default: true,
    },
    categoryLimit: null,
    seriesLimit: null,
  },
  column: {
    description: {
      name: 'Vertical Bar Chart',
      type: 'column',
    },
    market: {
      default: false,
      tickers: 1,
    },
    categoryLimit: null,
    seriesLimit: null,
  },
  bar: {
    description: {
      name: 'Horizontal Bar Chart',
      type: 'bar',
    },
    market: {
      default: false,
      tickers: Infinity,
    },
    categoryLimit: null,
    seriesLimit: null,
  },
  area: {
    description: {
      name: 'Area Chart',
      type: 'area',
    },
    market: false,
    categoryLimit: null,
    seriesLimit: null,
  },
  step: {
    description: {
      name: 'Step Chart',
      type: 'step',
    },
    market: false,
    categoryLimit: null,
    seriesLimit: null,
  },
  scatter: {
    description: {
      name: 'Scatter Chart',
      type: 'scatter',
    },
    market: false,
    categoryLimit: null,
    seriesLimit: {
      max: 4,
      min: 3,
    },
  },
  pie: {
    description: {
      name: 'Donut Chart',
      type: 'pie',
    },
    market: false,
    categoryLimit: {
      min: 2,
      max: 5,
    },
    seriesLimit: {
      max: 2,
      min: 2,
    },
  },
};

/**
 * An array of objects containing name and type of chart.
 * @return {ChartTypeDescription[]}
 */
export const POSSIBLE_CHARTS = Object.keys(CHART_TYPES).map(
  (type) => CHART_TYPES[type].description
);

/**
 * An array of chart types that can be used for single ticker market charts.
 * @return {ChartTypeDescription[]}
 */
export const MARKET_SINGLE_TICKER = Object.keys(CHART_TYPES).reduce((possibleCharts, type) => {
  const chart = CHART_TYPES[type];
  if (chart.market.default || chart.market.tickers === 1)
    possibleCharts.push(CHART_TYPES[type].description);
  return possibleCharts;
}, []);

/**
 * An array of chart types that can be used for multi ticker market charts.
 * @return {ChartTypeDescription[]}
 */
export const MARKET_MULTI_TICKER = Object.keys(CHART_TYPES).reduce((possibleCharts, type) => {
  const chart = CHART_TYPES[type];
  if (chart.market.default || chart.market.tickers > 1)
    possibleCharts.push(CHART_TYPES[type].description);
  return possibleCharts;
}, []);

/**
 * An object containing supported chart types for each publications
 */
export const SUPPORTED_CHART_TYPES = {
  wsj: ['line', 'column', 'bar', 'area', 'step', 'scatter'],
  barrons: ['line', 'column', 'bar', 'area', 'step', 'scatter', 'pie'],
  marketwatch: ['line', 'column', 'bar', 'area', 'step', 'scatter', 'pie'],
  mansionglobal: ['line', 'column', 'bar', 'area', 'step', 'scatter', 'pie'],
  fnlondon: ['line', 'column', 'bar', 'area', 'step', 'scatter', 'pie'],
  djriskjournal: ['line', 'column', 'bar', 'area', 'step', 'scatter', 'pie'],
};
